import moment from 'moment'
import * as math from '@/utils/index'
import { model } from "eco-cli";

// console.log("math: ", math);

export class File extends model.Model {
  fileName = '';
  fileId = '';
  fileSize = 0;
  fileIcon = '';
  // createTime = '';
  shareTime = moment();
  expireTime = ''; // 到期时间
  shareDate = moment();
  expireDate = ''; // 到期日期
  isExpire = false; // 是否过期
  type = '1'; // 0文件 1目录
  childFiles = [] // 目录文件列表
  breadList = [];
  isLoading = false; // 默认未加载
  // isHasLink = false;
  curPath = ''
  static blank() {
    return new this({});
  }
  static fromServer(json) {
    return File.new({
      fileName: json.name || '',
      fileId: json.id || '',
      fileIcon: math.getFileIcon(json),
      fileSize: math.sizeConversion(json.fileSize),
      shareTime: moment(json.shareTime).format('YYYY-MM-DD HH:mm'),
      // expireTime: json.overDate ? moment(json.overDate).format('YYYY-MM-DD HH:mm') : '永久有效',
      expireTime: json.overDate ? math.expireConversion(moment(json.overDate)) : '永久有效',
      shareDate: moment(json.shareTime).format('YYYY-MM-DD HH:mm'),
      expireDate: json.expireTime ? math.expireConversion2(moment(json.expireTime).add(1, 'days')): '',
      isExpire: moment(json.overDate).isBefore(moment(), 'day') || json.isValid === '1', // 0有效 1失效
      type: json.isDir,
      breadList: json.idPath && math.genBreadList(json),
      childFiles: json.childFiles && json.childFiles.map(item => File.fromServer(item)),
      // isHasLink: json.isHasLink,
      curPath: json.filePath,
      isLoading: false,
      // curId: math.getCurId(json.idPath),
      // curBreadList: math.gencurBreadList(json)
    })
  }
}

export class Share extends model.Model {
  fileId = '';
  files = [];
  static blank() {
    return new this({});
  }
  static fromServer(json) {
    return Share.new({
      fileId: json.linkId || '',
      files: json.fileLists && json.fileLists.map(item => File.fromServer(item)),
    })
  }
}
